export default "__VITE_ASSET__CGg7Id2t__"